module.exports = __webpack_public_path__ + "static/media/whatsapp-sync.27068195.svg";